'use strict';

module.exports.bytes = require('./bytes');



//////////////////
// WEBPACK FOOTER
// ./src/scripts/shared/filters/index.js
// module id = 205
// module chunks = 0